import React, { FC, lazy, memo } from 'react';

import {
  ERoutes,
  LeftColumnContent,
  MiddleColumnContent,
  SettingsScreens,
} from '../../../types';

import useLastCallback from '../../../hooks/useLastCallback';
import useHistoryBack from '../../../hooks/useHistoryBack';
import PaymentAiItem from './PaymentAiItem';
import AiPackPage from './AiPackPage';
import Transition from '../../ui/Transition';
import PaymentAiHeader from './PaymentAiHeader';
import { getActions, withGlobal } from '../../../global';
import { AiPrompt, GlobalState } from '../../../global/types';
import useEffectOnce from '../../../hooks/useEffectOnce';
import Loading from '../../ui/Loading';

import './PaymentAi.scss';

type OwnProps = {
  activePack: AiPrompt;
  setActivePack: (pack: AiPrompt | undefined) => void;
  prevMiddleScreen?: MiddleColumnContent;
};
type StateProps = Pick<GlobalState, 'aiPrompts' | 'payment'>;

const PaymentAi: FC<OwnProps & StateProps> = ({
  prevMiddleScreen,
  aiPrompts,
  activePack,
  payment,
  setActivePack,
}) => {
  const { getPriceAi } = getActions();

  const { toggleScreens } = useHistoryBack();

  const onReset = useLastCallback(() => {
    if (activePack) {
      setActivePack(undefined);
    } else {
      toggleScreens({
        pathname: ERoutes.aiSpace,
        middleScreen: MiddleColumnContent.Settings,
        settingScreen: SettingsScreens.aiSpace,
      });
    }
  });

  useEffectOnce(() => {
    getPriceAi();
  });

  return (
    <div id='PaymentAi' className='settings-layout'>
      <PaymentAiHeader name={activePack && activePack.name} onBack={onReset} />

      <Transition
        name='slide'
        activeKey={activePack ? 1 : 0}
        shouldCleanup
        cleanupExceptionKey={0}
      >
        {activePack ? (
          <AiPackPage prompt={activePack} payment={payment} />
        ) : (
          <div className='payment-content payment-items-wrap payment-wrap custom-scroll'>
            {aiPrompts ? (
              aiPrompts.map((item) => (
                <PaymentAiItem
                  key={item.name}
                  onByPack={setActivePack}
                  prompt={item}
                />
              ))
            ) : (
              <Loading />
            )}
          </div>
        )}
      </Transition>
    </div>
  );
};

export default memo(
  withGlobal((global): StateProps => {
    const { aiPrompts, payment } = global;
    return {
      aiPrompts,
      payment,
    };
  })(PaymentAi)
);
